import React from 'react';
import { motion } from 'framer-motion';
import { useInView } from 'framer-motion';
import { useRef } from 'react';
import { FaVideo, FaDollarSign, FaDiscord, FaTrophy, FaFire } from 'react-icons/fa';

const CreatorProgram = () => {
  const ref = useRef(null);
  const isInView = useInView(ref, { once: true, margin: "-100px" });

  return (
    <section ref={ref} className="relative py-40 px-4 overflow-hidden">
      {/* Subtle background */}
      <div className="absolute inset-0 bg-gradient-to-br from-rizzmas-red/3 via-rizzmas-gold/5 to-rizzmas-green/3" />

      <div className="max-w-5xl mx-auto relative z-10">
        {/* Main CTA Card */}
        <motion.div
          initial={{ opacity: 0, y: 30 }}
          animate={isInView ? { opacity: 1, y: 0 } : { opacity: 0, y: 30 }}
          transition={{
            duration: 0.6,
            delay: 0.2,
            ease: "easeOut"
          }}
        >
          <div className="bg-gradient-to-br from-rizzmas-dark via-rizzmas-dark to-rizzmas-red/20 border-2 border-rizzmas-gold/50 rounded-3xl p-12">
            {/* Content */}
            <div className="text-center">
              {/* Eyebrow */}
              <div className="flex items-center justify-center gap-2 mb-4">
                <FaFire className="text-rizzmas-red text-xl" />
                <span className="text-rizzmas-gold font-bold text-sm uppercase tracking-wider">Limited Spots Available</span>
                <FaFire className="text-rizzmas-red text-xl" />
              </div>

              {/* Main headline */}
              <h2 className="text-4xl md:text-6xl lg:text-7xl font-black mb-6 bg-gradient-to-r from-rizzmas-gold via-rizzmas-cream to-rizzmas-gold bg-clip-text text-transparent leading-tight">
                Get Paid to Create<br />$RIZZMAS Videos!
              </h2>

              {/* Description */}
              <p className="text-xl md:text-2xl text-rizzmas-cream/90 mb-12 max-w-3xl mx-auto leading-relaxed">
                Join our creator program and earn real $ for spreading the Rizzmas spirit. TikTok, YouTube, Twitter — we pay for quality content that goes viral.
              </p>

              {/* Features */}
              <div className="grid grid-cols-1 md:grid-cols-3 gap-6 mb-12">
                <div className="bg-rizzmas-red/20 border border-rizzmas-red/30 rounded-xl p-6">
                  <FaVideo className="text-4xl text-rizzmas-red mx-auto mb-3" />
                  <h3 className="text-lg font-bold text-rizzmas-cream mb-2">Create Content</h3>
                  <p className="text-sm text-rizzmas-cream/70">Post videos about $RIZZMAS on your favorite platforms</p>
                </div>

                <div className="bg-rizzmas-gold/20 border border-rizzmas-gold/30 rounded-xl p-6">
                  <FaDollarSign className="text-4xl text-rizzmas-gold mx-auto mb-3" />
                  <h3 className="text-lg font-bold text-rizzmas-cream mb-2">Get Paid</h3>
                  <p className="text-sm text-rizzmas-cream/70">Earn based on views, engagement, and virality</p>
                </div>

                <div className="bg-rizzmas-green/20 border border-rizzmas-green/30 rounded-xl p-6">
                  <FaTrophy className="text-4xl text-rizzmas-green mx-auto mb-3" />
                  <h3 className="text-lg font-bold text-rizzmas-cream mb-2">Win Bonuses</h3>
                  <p className="text-sm text-rizzmas-cream/70">Top performers get extra rewards and recognition</p>
                </div>
              </div>

              {/* Discord CTA */}
              <div>
                <a
                  href="https://discord.gg/s7fnEeWkg"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="inline-flex items-center gap-4 px-12 py-6 bg-[#5865F2] text-white text-xl md:text-2xl font-black rounded-xl hover:bg-[#4752C4] transition-colors duration-200"
                >
                  <FaDiscord className="text-3xl" />
                  Join Discord & Start Earning
                  <span>→</span>
                </a>

                <p className="mt-4 text-sm text-rizzmas-cream/60">
                  All campaigns are hosted in our Discord server
                </p>
              </div>
            </div>
          </div>
        </motion.div>
      </div>
    </section>
  );
};

export default CreatorProgram;
